import React from 'react';
import { bonuses, type Bonus } from '../data/bonuses';
const rows = ['bg-coral', 'bg-sage', 'bg-smoke', 'bg-gold'];
function BonusCover({
  bonus
}: {
  bonus: Bonus;
}) {
  if (bonus.cover) {
    return <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="aspect-square w-full border-b border-cream-dark object-cover object-center" data-id="element-23" data-mp="avv3e9gurcu2" />;
  }
  return <div aria-hidden="true" className="relative flex h-[230px] items-center justify-center border-b border-cream-dark bg-blush sm:h-[265px]" data-id="element-24" data-mp="1wriczy4kncx">
      <div className="relative w-[62%] max-w-[260px] aspect-[4/3] overflow-hidden rounded-md bg-cream shadow-cover ring-1 ring-black/5" data-id="element-25" data-mp="3o2wqzdp1jxl4">
        <span className={`absolute inset-x-0 top-0 h-[6%] ${bonus.accent}`} data-id="element-26" data-mp="3t2j4lo8s7fug" />
        <div className="px-[8%] pt-[12%]" data-id="element-27" data-mp="1mb1j795wod86">
          <span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-gold-deep" data-id="element-28" data-mp="1r9v07bkeimd3">
            Bonus {bonus.number}
          </span>
          <span className="mt-2 block font-display text-[15px] leading-tight text-plum sm:text-base" data-id="element-29" data-mp="3iclo5tyzymyv">
            {bonus.title}
          </span>
        </div>
        <span className="absolute bottom-[14%] left-[8%] font-display text-[10px] text-ink-soft" data-id="element-30" data-mp="3r700pos57jea">
          Session Ready SLP
        </span>
        <div className="absolute inset-x-0 bottom-0 flex h-[8%] flex-col" data-id="element-31" data-mp="3n5y7ppotk3kr">
          {rows.map(r => <span key={r} className={`flex-1 ${r}`} data-id="element-32" data-mp="2zhoiedsecxov" />)}
        </div>
      </div>
    </div>;
}
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-white" data-id="element-33" data-mp="38gilmn08gmbe">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-34" data-mp="33h5qlez7k8xq">
        <div className="text-center" data-id="element-35" data-mp="33fujb56k0j1v">
          <p className="text-[12px] font-bold uppercase tracking-[1.6px] text-coral-deep" data-id="element-36" data-mp="npriv4xf0jjk">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="mt-3 font-display text-plum text-3xl sm:text-5xl" data-id="element-37" data-mp="iqeycqu0nok5">
            Five instant-use <span className="text-smoke" data-id="element-38" data-mp="3hhr79jvlktzk">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-ink-soft" data-id="element-39" data-mp="3hk40it6t2qrx">
            The volumes give you the school year. These five get you running
            it this week.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-40" data-mp="3qglaht3foim3">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-3xl border border-cream-dark bg-cream ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-41" data-mp="2tqc3rns346mq" data-mpi={i}>
              <BonusCover bonus={bonus} data-id="element-42" data-mp="2a4pgt6pym42a" />
              <div className="px-5 pb-6 pt-4" data-id="element-43" data-mp="2a3o6x5kojnm5">
                <div className="flex flex-wrap items-center gap-2" data-id="element-44" data-mp="2f3iwn5spy75m">
                  <span className="text-[11px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-45" data-mp="2f1potn6ddgw1">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded-full bg-gold px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-gold-ink" data-id="element-46" data-mp="22lyc8yi6lrwr">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-xl leading-snug text-plum" data-id="element-47" data-mp="1tjgq0k2j0z9r">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-ink-soft" data-id="element-48" data-mp="1omypjwe8bn38">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}